import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';

import styles from './KnmActEventItemBodyProtocolFile.module.scss';

interface IErknmResultDecisionProtocolProps {
  attachmentsNumber: number;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  isWatchOnly: boolean;
  name: string;
  isDecision?: boolean;
  isPm?: boolean;
  actIndex?: number;
  eventIndex: number;
  eventId: string;
}

export const KnmActEventItemBodyProtocolFile = memo(
  ({
    attachmentsNumber,
    formRef,
    isWatchOnly,
    name,
    actIndex,
    eventIndex,
    isDecision,
    eventId,
    isPm,
  }: IErknmResultDecisionProtocolProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <FieldBlock
        label={getTitleFieldWithRedStar({
          label: 'Протокол проведенного действия',
          field: name,
          isPm,
          isDecision,
          isKnm: !isPm && !isDecision,
        })}
        className={styles.GroupMargin}
        id={`${eventId}.protocol.file.attachments`}
        button={
          <Button
            className="shared-btn-add"
            text="Добавить"
            variant="link"
            color="primary"
            type="button"
            id="fileAddButton"
            disabled={isWatchOnly || attachmentsNumber > 0}
            onClick={openSignModal}
          />
        }
      >
        <div className={styles.ActDocument}>
          <div className="shared-group-label">
            Файл&nbsp;
            <span className="shared-no-wrap-text">протокола</span>
          </div>
          <FormSpy subscription={{ errors: true, touched: true }}>
            {props => {
              let fieldError: string | undefined;

              if (!isDecision && actIndex !== undefined) {
                fieldError =
                  props.errors?.acts?.[actIndex]?.events &&
                  typeof eventIndex === 'number' &&
                  eventIndex > -1 &&
                  props.errors.acts[actIndex].events[eventIndex] &&
                  props.errors.acts[actIndex].events[eventIndex].protocol?.file?.attachments;
              } else {
                fieldError = props.errors?.act?.events?.[eventIndex]?.protocol?.file?.attachments;
              }

              if (fieldError) {
                if (typeof fieldError === 'string') {
                  return <p className="shared-input-error shared-row__small-margin">{fieldError}</p>;
                }
                if (typeof fieldError === 'object') {
                  Object.keys(fieldError).forEach(key => {
                    if (key === 'FINAL_FORM/array-error') {
                      fieldError = ((fieldError as unknown) as { [key: string]: string })[key];
                    }
                  });

                  if (fieldError) {
                    return <p className={`shared-input-error shared-row__small-margin`}>{fieldError}</p>;
                  }
                }
              }

              return null;
            }}
          </FormSpy>
          <KnmAttachmentsSigning
            isWatchOnly={isWatchOnly}
            name={name}
            isVisibleSignModal={isVisibleSignModal}
            closeSignModal={closeSignModal}
            acceptedFiles={'.pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip'}
            formRef={formRef}
          />
        </div>
      </FieldBlock>
    );
  },
);
